<script>

import { Bar } from 'vue-chartjs'

export default {
  extends: Bar,
  props: ['labels', 'data'],
  mounted () {
    var self = this
    this.renderChart({
      labels: self.labels,
      datasets: [{
        backgroundColor: 'rgba(255,255,255,.3)',
        borderColor: 'transparent',
        data: self.data
      }]
    }, {
      maintainAspectRatio: false,
      legend: {
        display: false
      },
      scales: {
        xAxes: [{
          display: false,
          categoryPercentage: 1,
          barPercentage: 0.5
        }],
        yAxes: [{
          display: false
        }]
      }
    })
  }
}
</script>


// WEBPACK FOOTER //
// src/components/ui/ChartBar.vue